/************************************************************************************

COMPONENTS:

+ Delivery Estimate

*************************************************************************************/
class LDeliveryEstimate extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.calculateDeliveryDate();
  }

  calculateDeliveryDate() {
    const deliveryDays = parseInt(this.dataset.deliveryDate, 10);
    if (isNaN(deliveryDays)) return;

    let deliveryDate = new Date();
    let daysAdded = 0;

    while (daysAdded < deliveryDays) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      if (deliveryDate.getDay() !== 0 && deliveryDate.getDay() !== 6) {
        daysAdded++;
      }
    }

    const options = { weekday: 'long', day: 'numeric', month: 'long' };
    const formattedDate = deliveryDate.toLocaleDateString('en-US', options);
    this.innerHTML = this.innerHTML.replace('[delivery_date]', formattedDate);
  }
}

customElements.define('l-delivery-estimate', LDeliveryEstimate);


class LSplitPayment extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener('product:variant-change', (event) => {
      const variant = event.detail.variant;

      this.innerHTML = this.dataset.paymentText.replace('[money]', formatMoney(variant.price));
    })
  }
}

customElements.define('l-product-split-payment', LSplitPayment);


/************************************************************************************

CUSTOM JS

*************************************************************************************/
document.addEventListener('DOMContentLoaded', () => {
  function simulateZoomButtons() {
    const zoomButtons = document.querySelectorAll('[id^="productZoomButton-"]');

    zoomButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const pswpTrigger = button.parentElement.querySelector('[data-pswp-trigger]');
        if (!pswpTrigger) return;

        pswpTrigger.dispatchEvent(new Event('click', {bubbles: true}));
      });
    });
  }


  // Run functions
  // simulateZoomButtons();
})
